import { render, staticRenderFns } from "./quan.vue?vue&type=template&id=25b2c48f&"
import script from "./quan.vue?vue&type=script&lang=js&"
export * from "./quan.vue?vue&type=script&lang=js&"
import style0 from "./quan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports